/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../components/datatable/customStyles';
import QRCode from 'react-qr-code';
import toast from 'react-hot-toast';
import { clients_services } from '../../services/clients_services';
import { toPng } from 'html-to-image';
import { dashboad } from '../../services/Dashboad';
import moment from 'moment';

const ListClientWaiting = () => {
    // Navigations
    const navigate = useNavigate()
    const home = () => {
        navigate('/company/dashboad');
    };
    const client_waiting = () => {
        navigate('/company/list/clientWaiting');
    };

    // declaration 
    const qrRef = useRef(null)
    const [wait, setWait] = useState(true)
    const [state, setState] = useState(0)
    const [id, setId] = useState('')
    const [clients, setClients] = useState([]);
    const [clientd, setClientd] = useState({})
    const [updateId, setUpdateId] = useState('')
    const [clientUpdate, setClientUpdate] = useState({})
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [sortGender, setSortGender] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [sortFilter, setSortFilter] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false); // État pour le modal
    const [typeIntervention, setTypeIntervention] = useState('');
    const [getScanHistory, setGetScanHistory] = useState([]);

    // detail client info
    useEffect(() => {
        if (id !== '') {
            clients_services.getClient(id)
                .then((res) => {
                    // console.log("ClientDetailRes:", res.data.client);
                    setTypeIntervention(res.data.typeIntervention)
                    setClientd(res.data.client)
                })
                .catch((err) => {
                    console.log(err)
                    if (err.response) {
                        if (err.response.status === 400) {
                            navigate("/auth/loginCompany");
                            // swal({
                            //     text: "Votre session a expiré, veillez vous reconnecter",
                            //     icon: "error",
                            //     button: "Fermer",
                            // });
                        }
                        if (err.response.status === 404) {
                            toast("Utilisateur introuvable")
                        }
                        if (err.response.status === 403) {
                            toast.error("Erreur lors de la recuperation du client");
                        }
                        if (err.response.status === 500) {
                            toast.error("Erreur d'exéciution dans l'application , veillez vous reconnecter.")
                        }
                    }
                }
                );
        }
    }, [id]);

    // get client info function historic
    const getClient = () => {
        if (id !== '') {
            clients_services.getScanHistory(id)
                .then((res) => {
                    // console.log("getScanHistoryres:::", res.data.storyScan);
                    setGetScanHistory(res.data.storyScan)
                })
                .catch((err) => {
                    console.log("error while getScanHistoryres", err)
                    if (err.response) {
                        if (err.response.status === 400) {
                            navigate("/auth/loginCompany");
                            // swal({
                            //     text: "Votre séssion a expiré, veillez vous reconnecter",
                            //     icon: "error",
                            //     button: "Fermer",
                            // });
                        }
                        if (err.response.status === 404) {
                            toast("Utilisateur introuvable")
                        }
                        if (err.response.status === 403) {
                            toast.error("Erreur lors de la recuperation du client");
                        }
                        if (err.response.status === 500) {
                            toast.error("Erreur d'exéciution dans l'application , veillez vous reconnecter.")
                        }
                    }
                });
        }
    }
    // get client histoty info
    useEffect(() => {
        getClient()
    }, [id]);

    // get all client function
    const getClientEnAttente = () => {
        dashboad.listClientEnAttente()
            .then((res) => {
                // console.log("listClientEnAttenteRes : ", res.data)
                setClients(res.data.listClientEnAttente)
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                        // swal({
                        //     text: "Votre session a expiré, veillez vous reconnecter",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                    }
                    if (err.response.status === 404) {
                        toast("Utilisateur introuvable")
                    }
                    if (err.response.status === 403) {
                        toast.error("Erreur lors de la récuperation des clients");
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous réconnecter.")
                    }
                }
            }
            )
    }

    // Retrieve the clients when the component is mounted and each time the sorting/filtering criteria change
    useEffect(() => {
        getClientEnAttente();
    }, [sortOrder, sortFilter, sortGender, state]);

    // Définir les colonnes du tableau
    const columns = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            width: '60px',
            sortable: true,
        },
        {
            name: 'Nom',
            selector: (row) => row.nom,
            sortable: true,
        },
        {
            name: 'Prénom',
            selector: (row) => row.prenom,
            sortable: true,
        },
        {
            name: 'Localisation',
            selector: (row) => row.localisation,
            sortable: true,
        },
        {
            name: 'Téléphone',
            selector: (row) => row.numeroTel,
            sortable: true,
        },
        {
            name: 'Genre',
            selector: (row) => row.sexe,
            sortable: true,
        },
        {
            name: 'conso.',
            selector: (row) => row.intervention,
            sortable: true,
        },
        {
            name: 'Code.U',
            selector: (row) => row.code,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className='action-container d-flex'>
                    <button className="btn btn-primary btn-xs" title='Voir plus de detail' data-toggle="modal" data-target="#modal-detail" onClick={() => setId(row.id)} ><i className="fas fa-eye " /></button>
                    <button className="btn btn-warning btn-xs mx-3" title='Modifier' data-toggle="modal" data-target="#modal-edit" onClick={() => { setUpdateId(row.id); setIsModalOpen(true); }}><i className="fas fa-edit" /></button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const transformedData = getScanHistory.map((row) => ({
        ...row,
        showNbVisite: row.Structure.typeInterventionId === 1,
        showQuantite: row.Structure.typeInterventionId === 2,
    }));

    const columnsHistory = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: 'Date',
            selector: (row) => moment(row.date).format('YYYY-MM-DD'),
            sortable: true,
        },
        {
            name: 'heure',
            selector: (row) => row.heure,
            sortable: true,
        },
        {
            name: 'Nb.Visite',
            selector: (row) => row.nbrVisiteClient,
            sortable: true,
            omit: !transformedData.some((row) => row.showNbVisite),
        },
        {
            name: 'Quantité',
            selector: (row) => row.nbrVisiteClient,
            sortable: true,
            omit: !transformedData.some((row) => row.showQuantite),
        },
    ];

    // Function to filter and sort client based on current status
    const getClientsSortAdnfilter = () => {
        let clientsFilters = clients

        // Apply gender filter
        if (sortGender) {
            clientsFilters = clientsFilters.filter((clients) => clients.sexe === sortGender);
        }

        // sort clients info
        clientsFilters.sort((a, b) => {
            if (sortOrder === 'desc') {
                if (sortFilter === 'nom') {
                    return b.nom.localeCompare(a.nom);
                } else if (sortFilter === 'prenom') {
                    return b.prenom.localeCompare(a.prenom);
                } else if (sortFilter === 'localisation') {
                    return b.localisation.localeCompare(a.localisation);
                } else if (sortFilter === 'numeroTel') {
                    return b.numeroTel.localeCompare(a.numeroTel);
                }
            } else {
                if (sortFilter === 'nom') {
                    return a.nom.localeCompare(b.nom);
                } else if (sortFilter === 'prenom') {
                    return a.prenom.localeCompare(b.prenom);
                } else if (sortFilter === 'localisation') {
                    return a.localisation.localeCompare(b.localisation);

                } else if (sortFilter === 'numeroTel') {
                    return a.numeroTel.localeCompare(b.numeroTel);
                }
            }
        });

        return clientsFilters
    }

    // Mettre à jour les données filtrées et triées chaque fois que l'un des états change
    useEffect(() => {
        const sortedFilteredClients = getClientsSortAdnfilter();
        setFilteredData(sortedFilteredClients);
    }, [clients, sortOrder, sortFilter, sortGender]);

    // Filtrer les données en fonction du texte de recherche
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        const filtered = getClientsSortAdnfilter().filter(item => {

            return (
                item.nom.toLowerCase().includes(value.toLowerCase()) ||
                item.prenom.toLowerCase().includes(value.toLowerCase()) ||
                item.localisation.toLowerCase().includes(value.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };

    // update client function
    useEffect(() => {
        if (updateId !== '') {
            clients_services.getClient(updateId)
                .then((res) => {
                    // console.log("companyUpdateRES ::", res.data.client)
                    setClientUpdate(res.data.client)
                })
                .catch((err) => {
                    console.log(err)
                    if (err.response) {
                        if (err.response.status === 400) {
                            navigate("/auth/loginCompany");
                            // swal({
                            //     text: "Votre séssion a expiré, veillez vous reconnecter",
                            //     icon: "error",
                            //     button: "Fermer",
                            // });
                        }
                        if (err.response.status === 404) {
                            toast("Utilisateur introuvable")
                        }
                        if (err.response.status === 403) {
                            toast.error("Erreur lors de la récuperation du client");
                        }
                        if (err.response.status === 500) {
                            toast.error("Erreur d'exéciution dans l'application , veillez vous reconnecter.")
                        }
                    }
                });
        }
    }, [updateId]);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onChange = (e) => {
        setClientUpdate({
            ...clientUpdate,
            [e.target.name]: e.target.value
        })
    }
    const onSubmit = (e) => {
        e.preventDefault();

        // Vérifications initiales
        if (!clientUpdate.nom || !clientUpdate.numeroTel || !clientUpdate.sexe || !clientUpdate.localisation) {
            toast.error("Veillez remplir tous les champs obligatoires!");
            return;
        }

        if (clientUpdate.numeroTel.length < 9) {
            toast.error("Le numéro de téléphone doit contenir au moins 9 chiffres.");
            return;
        }

        if (clientUpdate.nom.length > 30) {
            toast.error("Le champ nom ne doit pas dépasser 30 caractères.");
            return;
        }

        // Début du traitement
        setWait(true);

        clients_services
            .updateClient(updateId, clientUpdate)
            .then((res) => {
                if (res.status === 201) {
                    // Mettez à jour les états ou données nécessaires
                    setState((current) => current + 1);

                    // Redirigez une fois tout terminé
                    toast.success("Structure modifiée avec succès.");
                    navigate("/company/list/client");

                    // Fermer la modal
                    closeModal();
                    const backdrop = document.querySelector(".modal-backdrop");
                    if (backdrop) {
                        backdrop.remove();
                    }

                }
            })
            .catch((err) => {
                console.error("Erreur :", err);
                setWait(false);

                if (!err.response) {
                    toast.error("Erreur réseau ou serveur non atteignable.");
                    return;
                }

                switch (err.response.status) {
                    case 400:
                        navigate("/auth/loginCompany");
                        // swal({
                        //     text: "Votre session a expiré, veillez vous connecter.",
                        //     icon: "error",
                        //     button: "Fermer",
                        // });
                        break;
                    case 403:
                        toast.error("Le client sélectionné n'existe pas.");
                        break;
                    case 404:
                        toast.error("Utilisateur introuvable.");
                        break;
                    case 405:
                        toast.error("Erreur lors de la modification de client.");
                        break;
                    case 500:
                        toast.error("Erreur d'exécution dans l'application.");
                        break;
                    default:
                        toast.error("Une erreur inconnue s'est produite.");
                }
            })
            .finally(() => {
                setWait(false); // Fin du chargement
            });
    };

    // put client into qr code 
    const clientInfo = JSON.stringify({
        Id: clientd.id,
        Nom: clientd.nom,
        Prenom: clientd.prenom,
        Telephone: clientd.numeroTel,
        Localisation: clientd.localisation,
        Intervention1: clientd.intervention1,
        Intervention2: clientd.intervention2,
        Sexe: clientd.sexe,
        DateCreation: clientd.createdAt,
        Structure: clientd.StructureId,
        Bonus: clientd.bonus
    });

    // Function to format the current date and time as 'YYYY-MM-DD_HH-MM'
    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}_${hours}-${minutes}`;
    };

    // Function to download QR code as image with custom filename
    const downloadQrCode = () => {
        if (qrRef.current === null) {
            return;
        }
        // Format the filename as "GuestName-EventName-DateTime.png"
        const dateTime = getFormattedDateTime(); // Get the current date and time
        const filename = `${clientd.nom}_${clientd.prenom}-${dateTime}.png`;

        toPng(qrRef.current)
            .then((dataUrl) => {
                const link = document.createElement('a');
                link.download = filename; // Set the filename dynamically-
                link.href = dataUrl;
                link.click();
            })
            .catch((err) => {
                console.error('Error generating image', err);
            });
    };

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Gestion des clients</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item link"><a onClick={home}>Acceuil</a></li>
                                    <li className="breadcrumb-item link"><a onClick={client_waiting}>Clients</a></li>
                                    <li className="breadcrumb-item active">Liste des clients en attentes</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header ">
                                            <h3 className="card-title"><i className="fas fa-list mr-2 text-light titleIcon"></i> Liste des clients en attentes</h3>

                                            {/* <strong className='total_entree'>   Total : {clients.length}</strong> */}

                                            <button className="btn btn-light text-success shadow btn-xs" onClick={home} title='Retour au tableau de bord' style={{ position: 'relative', float: 'right' }}>
                                                <i className="mr-1 fas fa-arrow-left" />
                                                Rétour
                                            </button>
                                        </div>

                                        <div className="card-body">
                                            <form className="form filtre align-items-center d-flex justify-content-between flex-wrap" >
                                                <div>
                                                    <label htmlFor="orderOption"> Trier par..</label>
                                                    <select className="optionSelect" value={sortOrder} name={sortOrder} onChange={(e) => setSortOrder(e.target.value)} id='orderOption'>
                                                        <option value="" selected >---</option>
                                                        <option value="asc">Ordre croissant</option>
                                                        <option value="desc">Ordre décroissant</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label htmlFor="filterOption"> Filtrer par..</label>
                                                    <select className="optionSelect ml-2" value={sortFilter} name={sortFilter} onChange={(e) => setSortFilter(e.target.value)} id='filterOption'>
                                                        <option value="" selected >---</option>
                                                        <option value="nom">Nom</option>
                                                        <option value="prenom">Prénom</option>
                                                        <option value="localisation">Localisation</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label htmlFor="genderOption">Sexe..</label>
                                                    <select className="optionSelect" value={sortGender} name={sortGender} onChange={(e) => setSortGender(e.target.value)} id='genderOption'>
                                                        <option value="" selected >---</option>
                                                        <option value="masculin">Masculin</option>
                                                        <option value="feminin">Feminin</option>
                                                    </select>
                                                </div>
                                                <div className="">
                                                    <input
                                                        className='search optionSelect'
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        value={searchText}
                                                        onChange={handleSearch}
                                                    />
                                                </div>
                                            </form>
                                            <DataTable
                                                columns={columns}
                                                data={filteredData}
                                                striped
                                                highlightOnHover
                                                customStyles={customStyles}
                                                pagination
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* client detail modal */}
            <div className="modal fade" id="modal-detail">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title modal-title-sm">Détail du client  : <strong className='ml-2 capitalize'>{clientd.nom + " " + clientd.prenom}</strong> </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button></div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="row ">
                                    <div className="col-md-6 shadow text-center qr-container">
                                        <div className="qr-code-container">
                                            <QRCode
                                                className='link qr-code'
                                                ref={qrRef}
                                                onClick={downloadQrCode}
                                                value={clientInfo}
                                                size={256}
                                            />
                                            {/* <QRCode value={jsonData} size={256} /> */}

                                            <button onClick={downloadQrCode} className="bouton-qr" title='Cliquer pour télécharger le Code QR' >
                                                Télécharger le QR Code
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        {/* <div className="texte ">Bonjours tous le monda , c'est</div> */}
                                        <div className="fw-bold name mt-2"><h4><strong className='capitalize shadow px-2 py-2'>{clientd.nom + " " + clientd.prenom}</strong></h4></div>
                                        <div className="mt-3"><i className='fas fa-map-marker-alt mr-2 ml-2'></i>{clientd.localisation}</div>
                                        <div className="mt-3"><i className='fas fa-phone mr-2 ml-2'></i> (+237) {clientd.numeroTel} </div>
                                        <div className="mt-3"><i className={typeIntervention === 2 ? "fas fa-dumbbell mr-2 ml-2" : "fas fa-infinity mr-2 ml-2"}></i> {clientd.intervention} <strong>{typeIntervention === 1 ? "Visite(s)" : "Kg"}</strong></div>
                                        {/* <div className="mt-3"><i className='fas fa-infinity mr-2 ml-2'></i>{clientd.intervention1}  <strong>Visite(s)</strong></div> */}
                                        <div className="mt-3 capitalize">
                                            {
                                                clientd.sexe === 'masculin' ? <i className="fas  mr-2 ml-2 fa-mars"></i> :
                                                    clientd.sexe === 'feminin' ? <i className="fas  mr-2 ml-2 fa-venus"></i> : ''
                                            }
                                            {clientd.sexe}
                                        </div>

                                        <div className="mt-3"> Bonus atteint : <strong className='text-success'>{clientd.bonus}</strong></div>
                                        {/* <div className="mt-3 ml-2"><span className={clientd.statut ===  ? "badge badge-success" : "badge badge-danger"}>{clientd.bonus === true ? "Activé" : "Désactivé"}</span></div> */}

                                    </div>

                                </div>
                            </div>
                            <div className='mt-2'>
                                <DataTable
                                    columns={columnsHistory}
                                    data={getScanHistory}
                                    striped
                                    highlightOnHover
                                    customStyles={customStyles}
                                    pagination
                                />
                            </div>
                        </div>
                        <div className="modal-footer  justify-content-between">
                            <button className="btn btn-secondary btn-sm" data-dismiss="modal" title='Fermer'><i className="fas fa-times mr-1"></i>Fermer</button>
                            <div className="btn">
                                <button type="button" className="btn btn-warning btn-sm ml-2" title="Modifier les informations du client" data-dismiss="modal" data-toggle="modal" data-target="#modal-edit" onClick={() => { setUpdateId(clientd.id); setIsModalOpen(true); }}>
                                    <i className="fas fa-edit mr-1" title="Modifier les info l'utilisateur"></i>
                                    Modifier
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* update client modal  */}
            {isModalOpen && (
                <div className="modal fade" id="modal-edit">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Modification du client  : <strong className='ml-2 capitalize'> {clientUpdate.nom + " " + clientUpdate.prenom}</strong> </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <form className="row form" onSubmit={onSubmit}>
                                <div className="modal-body">
                                    <div className="container">
                                        <div className="row ">
                                            <p className=''>
                                                Veillez vérifier le formulaire et mettre a jour les informations de l'utilisateur pour assurer leurs exactitude.
                                            </p>
                                            <div className="col-md-6">
                                                <label htmlFor="nom" className="form-label">
                                                    Nom
                                                </label>
                                                <input
                                                    type="text"
                                                    name="nom"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="nom" value={clientUpdate.nom} onChange={onChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="prenom" className="form-label">
                                                    Prénom
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="prenom"
                                                    name="prenom" value={clientUpdate.prenom} onChange={onChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="localisation" className="form-label">
                                                    Localisation
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="localisation"
                                                    name="localisation" value={clientUpdate.localisation} onChange={onChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="numeroTel" className="form-label">
                                                    Téléphone
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control no-focus-outline mb-2"
                                                    id="numeroTel"
                                                    name="numeroTel" value={clientUpdate.numeroTel} onChange={onChange}
                                                />
                                            </div>

                                            <div className="col-md-12">
                                                <label htmlFor="sexe">
                                                    Sexe
                                                    <span className="text-danger taille_etoile">*</span>
                                                </label>
                                                <select className="form-control mb-2" id='sexe' name='sexe' onChange={onChange}>
                                                    <option value="" className='text-info' disabled selected>Selectionner votre sexe</option>
                                                    <option value="masculin">Masculin</option>
                                                    <option value="feminin">Feminin</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <button type="button" className="btn btn-secondary btn-sm" data-dismiss="modal" title='Fermer'><i className='fas fa-times f-3 mr-1'></i>Fermer</button>
                                            <div className="d-flex">
                                                {/* <button type="reset" className="btn btn-secondary btn-sm mr-2" ><i className='fas fa-undo mr-1 f-3' aria-hidden="true" ></i>Annuler</button> */}

                                                {
                                                    wait ?
                                                        <button type="submit" className="btn btn-warning btn-sm" title='Modifier'> <i className='fas fa-edit mr-1 f-3'></i>Modifier</button>
                                                        :
                                                        <button className="btn btn-warning btn-sm"> <span className="spinner-border text-black spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Modification..</button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default ListClientWaiting;